import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { submitFreelancerApplication } from '../supabaseService';

const NAVY = '#14213d';
const GOLD = '#C9A84C';
const PHONE_RE = /^[6-9]\d{9}$/;

function isFullName(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  return parts.length >= 2 && !/\d/.test(name);
}

export default function FreelancerApplyPage() {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [village, setVillage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmedName = name.trim();
    const digits = phone.replace(/\D/g, '').slice(-10);
    if (!isFullName(trimmedName)) {
      setError('पूर्ण नाव लिहा (पहिले + आडनाव, PAN card प्रमाणे)');
      return;
    }
    if (!PHONE_RE.test(digits)) {
      setError('वैध 10-अंकी मोबाइल नंबर लिहा');
      return;
    }
    setSubmitting(true);
    const { item, error: submitError } = await submitFreelancerApplication({
      name: trimmedName,
      phone: digits,
      village: village.trim(),
    });
    setSubmitting(false);
    if (submitError) {
      setError(submitError);
      return;
    }
    setSuccess(item);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: `linear-gradient(180deg, ${NAVY} 0%, #0a1628 100%)`,
        color: '#e8ecf1',
        fontFamily: "'Noto Sans Devanagari', 'Plus Jakarta Sans', sans-serif",
        padding: '24px 16px',
      }}
    >
      <div style={{ maxWidth: 420, margin: '0 auto' }}>
        <p style={{ margin: 0, textAlign: 'center', color: GOLD, fontWeight: 700, fontSize: 13 }}>
          Development Express
        </p>
        <h1 style={{ margin: '8px 0 4px', textAlign: 'center', fontSize: 22, color: '#fff' }}>
          Freelancer Registration
        </h1>
        <p style={{ margin: '0 0 24px', textAlign: 'center', fontSize: 13, color: '#9aa8b8' }}>
          Field survey team — admin approval नंतर unique ID code मिळेल
        </p>

        {success ? (
          <div
            style={{
              border: `1px solid ${GOLD}55`,
              borderRadius: 16,
              padding: 20,
              background: 'rgba(201,168,76,0.08)',
              textAlign: 'center',
            }}
          >
            <p style={{ margin: 0, fontSize: 16, color: '#fff' }}>Application submitted!</p>
            <p style={{ margin: '12px 0 0', fontSize: 14, color: GOLD }}>
              Temporary ID: <strong>{success.code}</strong>
            </p>
            <p style={{ margin: '12px 0 0', fontSize: 13, color: '#9aa8b8' }}>
              Admin approve केल्यावर QR card व survey काम सुरू करू शकता.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <label style={{ fontSize: 12, color: '#9aa8b8' }}>
              Full name (PAN card style) *
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Yashraj Patil"
                maxLength={80}
                style={inputStyle}
              />
            </label>
            <label style={{ fontSize: 12, color: '#9aa8b8' }}>
              Mobile *
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="9876543210"
                inputMode="numeric"
                style={inputStyle}
              />
            </label>
            <label style={{ fontSize: 12, color: '#9aa8b8' }}>
              Village / Area
              <input
                value={village}
                onChange={(e) => setVillage(e.target.value)}
                placeholder="Malkapur"
                maxLength={80}
                style={inputStyle}
              />
            </label>
            {error && <p style={{ margin: 0, color: '#f87171', fontSize: 13 }}>{error}</p>}
            <button type="submit" disabled={submitting} style={buttonStyle}>
              {submitting ? 'Submitting…' : 'Submit for approval'}
            </button>
          </form>
        )}

        <p style={{ marginTop: 24, textAlign: 'center', fontSize: 12, color: '#6b7a8d' }}>
          <Link to="/" style={{ color: GOLD }}>Development Express</Link>
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  display: 'block',
  width: '100%',
  marginTop: 6,
  padding: '10px 12px',
  borderRadius: 10,
  border: '1px solid rgba(201,168,76,0.25)',
  background: '#0c1a30',
  color: '#fff',
  fontSize: 14,
  boxSizing: 'border-box',
};

const buttonStyle = {
  marginTop: 8,
  padding: '12px 16px',
  borderRadius: 10,
  border: 'none',
  background: GOLD,
  color: NAVY,
  fontWeight: 700,
  fontSize: 14,
  cursor: 'pointer',
};
